class ProductPersonalization extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.formId);
    this.toggle = this.querySelector("[data-personalization-toggle]");
    this.field = this.querySelector("[data-personalization-field]");
    this.input = this.querySelector("[data-personalization-input]");
    this.maxCount = this.querySelector("[data-personalization-count]");

    if (!this.form || !this.toggle || !this.input || !this.field) {
      return;
    }

    this._onToggleChange = this._syncState.bind(this);
    this._onInputChange = this._updateCount.bind(this);

    this.toggle.addEventListener("change", this._onToggleChange);
    this.input.addEventListener("input", this._onInputChange);

    this._syncState();
    this._updateCount();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener("change", this._onToggleChange);
    this.input?.removeEventListener("input", this._onInputChange);
  }

  isActive() {
    return Boolean(this.toggle?.checked && this.dataset.addonVariantId);
  }

  _syncState() {
    const isActive = this.toggle.checked;

    this.field.hidden = !isActive;
    this.input.disabled = !isActive;
    this.input.required = isActive;

    if (!isActive) {
      this.input.value = "";
    }

    this._updateCount();
  }

  _updateCount() {
    if (!this.maxCount) {
      return;
    }

    const maxLength = Number(this.input.getAttribute("maxlength")) || 0;

    if (!maxLength) {
      this.maxCount.textContent = "";
      return;
    }

    this.maxCount.textContent = `${this.input.value.length}/${maxLength}`;
  }
}

if (!window.customElements.get("product-personalization")) {
  window.customElements.define("product-personalization", ProductPersonalization);
}
